export default __webpack_public_path__ + "19c567c62daed89e1cab4b0837dab97a.png";